import * as React from 'react';
import { Page, PageContent } from '../components/common';
import { Helmet } from 'react-helmet';

interface Props {}
const PrivacyPolicyPage: React.StatelessComponent<Props> = props => {
	return (
		<Page>
			<Helmet>
				<meta charSet="utf-8"/>
				<meta
					name="description"
					content={`Mosaic Life's Privacy Policy protects the data of our customers who purchase life insurance through our website.`}
				/>
				<title>Privacy Policy | Mosaic Life</title>
			</Helmet>
			<PageContent>
				<header className="page-header mb-4 mb-md-5'">
					<h1 className="page-header-title">Privacy Policy</h1>
					<p className="mb-0">
						We are committed to maintaining the security, confidentiality and accuracy of all personal information under
						our control. As part of this commitment, we have established the following TEN PRIVACY PRINCIPLES that
						govern our information handling practices:
					</p>
				</header>
				<h2 className="h4 mt-4">Principle 1 - Accountability</h2>
				<p>
					We are responsible for personal information under our control and we have designated one or more persons who
					are accountable for our compliance with the privacy principles.
				</p>
				<h2 className="h4 mt-4">Principle 2 - Identifying Purposes for Collection of Personal Information</h2>
				<p>
					We identify the purposes for which personal information is collected at or before the time the information is
					collected.
				</p>
				<h2 className="h4 mt-4">
					Principle 3 - Obtaining Consent for Collection, Use, or Disclosure of Personal Information
				</h2>
				<p>
					We obtain the customer's consent to the collection, use or disclosure of personal information unless consent
					is not required by law.
				</p>
				<h2 className="h4 mt-4">Principle 4 - Limiting Collection of Personal Information</h2>
				<p>
					We limit the collection of personal information to that which is necessary for the purposes identified. We
					only collect personal information by fair and lawful means.
				</p>
				<h2 className="h4 mt-4">Principle 5 - Limiting Use, Disclosure and Retention of Personal Information</h2>
				<p>
					We do not use or disclose personal information for purposes other than those for which it was collected,
					except with the consent of the individual or as permitted by law. We retain personal information only as long
					as is necessary and in accordance with statutory requirements.
				</p>
				<h2 className="h4 mt-4">Principle 6 - Accuracy of Personal Information</h2>
				<p>
					Personal information is maintained in as accurate and up to date a form as is necessary to fulfill the
					purposes for which it is to be used.
				</p>
				<h2 className="h4 mt-4">Principle 7 - Safeguarding Personal Information</h2>
				<p>
					We protect personal information with appropriate security safeguards in accordance with legislated
					requirements.
				</p>
				<h2 className="h4 mt-4">Principle 8 - Openness Concerning Protocol and Practices</h2>
				<p>
					We make information available to our individual customers and employees concerning the policies and practices
					that apply to the management of their personal information.
				</p>
				<h2 className="h4 mt-4">Principle 9 - Customer and Employee Access to Personal Information</h2>
				<p>
					Upon request, individual customers and employees will be informed of the existence, use and disclosure of
					their personal information, and be given access to it. Individual customers and employees may verify the
					accuracy and completeness of their information, and may request that the information be amended where
					appropriate.
				</p>
				<h2 className="h4 mt-4">Principle 10 - Handling Customer Complaints and Suggestions</h2>
				<p>
					Individual customers or employees may direct any questions or inquiries with respect to the privacy principles
					outlined above or about our practices to our Corporate Privacy Officer.
				</p>
				<h2 className="h4 mt-4">Personal Information Practices</h2>
				<p>
					<strong>What personal information is collected:</strong> The personal information we ask for depends on the
					nature of the service or product requested and is limited to the information needed to process that request or
					to provide better service. This refers to personal information contained in applications for insurance
					protection and information required to process claims made by policyholders, all of which can include personal
					medical and financial information. We seek to balance the company's need to use such information for
					reasonable business purposes and individuals' right to privacy in respect of their personal information.
				</p>
				<p>
					<strong>How personal information is collected:</strong> Most of the information we collect comes directly from
					the customer or indirectly from a third party. If a third party requires consent to disclose information, a
					signed Information Release form is obtained from the customer. If information is being collected by telephone,
					the call may be recorded and/or monitored. Telephone call recordings are used for quality assurance, training,
					and to establish a record of the information you provide. If you are not comfortable with having your
					telephone calls recorded, you have the option of communicating with us in writing. This communication should
					also request that we respond to you in writing.
				</p>
				<p>
					<strong>How personal information is used:</strong> We use personal information to communicate, to deliver
					products and services you have requested, and to provide information about additional products and services
					that we believe might be of benefit and interest to you.
				</p>
				<p>
					<strong>Disclosing personal information to outside parties:</strong> We are required to keep your personal
					information confidential at all times, except under the following circumstances:
				</p>
				<ul>
					<li>When authorized by the party in question; or</li>
					<li>
						When required or otherwise authorized by law. This occurs when medical or security reasons may make it
						impossible or impractical to seek consent, such as during an investigation of a potential breach of
						contract, detection of fraud, and/or law enforcement purposes, where seeking consent may be inappropriate
						when the individual is a minor, seriously ill or otherwise incapacitated.
					</li>
				</ul>
				<p>
					<strong>Safeguarding information:</strong> We maintain security standards to ensure that all personal
					information is protected against unauthorized access, unauthorized disclosure, misuse, or inappropriate
					alteration.
				</p>
				<p>
					<strong>Accessing and amending information:</strong> All individual customers have the right to access, verify
					and amend the personal information held by us. At any time you may withdraw this authorization, or vary
					(limit) the consent given. When such action is taken, it is our responsibility to explain the implications of
					such withdrawal, or variation, which may include termination of the insurance protection, or the inability to
					complete business transactions. To submit a request for access to personal information, customers are asked to
					contact our Corporate Privacy Officer.
				</p>
				<p>
					<strong>Questions, concerns and complaints:</strong> If there are any questions about our Privacy Protocol or
					concerns or complaints about privacy, confidentiality, or our information handling practices, our customers
					are advised to please contact our Corporate Privacy Officer. If you are not satisfied with the response you
					receive, you may contact the Information & Privacy Commissioner of Alberta.
				</p>
			</PageContent>
		</Page>
	);
};
export default PrivacyPolicyPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/PrivacyPolicyPage.tsx